module.exports = __webpack_public_path__ + "img/2019-4.dd19f8e0.jpg";